// Re-export shared theme and create framework-specific configurations
import { sharedTheme } from './shared';

export { sharedTheme };

// Mantine-specific theme configuration
export const mantineTheme = {
  fontFamily: sharedTheme.fonts.sans,
  fontFamilyMonospace: sharedTheme.fonts.mono,
  headings: {
    fontFamily: sharedTheme.fonts.sans,
  },
  fontSizes: {
    xs: sharedTheme.fontSizes.xs,
    sm: sharedTheme.fontSizes.sm,
    md: sharedTheme.fontSizes.base,
    lg: sharedTheme.fontSizes.lg,
    xl: sharedTheme.fontSizes.xl,
    '2xl': sharedTheme.fontSizes['2xl'],
    '3xl': sharedTheme.fontSizes['3xl'],
    '4xl': sharedTheme.fontSizes['4xl'],
  },
  colors: {
    customBlue: sharedTheme.colors.customBlue,
    gray: sharedTheme.colors.gray,
    // Add customBlue as a primary color option
    blue: sharedTheme.colors.customBlue,
    customOrange: sharedTheme.colors.customOrange,
  },
  primaryColor: 'customBlue',
  spacing: {
    xs: sharedTheme.spacing[2], // 0.5rem
    sm: sharedTheme.spacing[3], // 0.75rem
    md: sharedTheme.spacing[4], // 1rem
    lg: sharedTheme.spacing[5], // 1.25rem
    xl: sharedTheme.spacing[8], // 2rem
    '2xl': sharedTheme.spacing[10], // 2rem
    '3xl': sharedTheme.spacing[12], // 2rem
    'text-card-spacing': sharedTheme.spacing['text-card-spacing'], // 100px
  },
  radius: {
    xs: sharedTheme.borderRadius.sm, // 0.125rem
    sm: sharedTheme.borderRadius.base, // 0.25rem
    md: sharedTheme.borderRadius.lg, // 0.5rem
    lg: sharedTheme.borderRadius.xl, // 1rem
    xl: sharedTheme.borderRadius['2xl'], // 2rem
  },
  breakpoints: {
    xs: sharedTheme.breakpoints.xs,
    sm: sharedTheme.breakpoints.sm,
    md: sharedTheme.breakpoints.md,
    lg: sharedTheme.breakpoints.lg,
    xl: sharedTheme.breakpoints.xl,
  },
};

// Re-export utilities
export * from './utils';
